import { Box, Stack, useTheme } from "@mui/material";
import TitleComponent from "../../../components/widgets/titleComponent";
import BreadCrumbComponent from '../../../components/widgets/breadcrumbComponent';
import { useTranslation } from "react-i18next";
import TabsComponent from "../../../components/widgets/tabsComponent";
import JobOverview from "./jobOverview";
import JobApplication from "./jobApplication";

const JobDetails = ({
    data
}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 15, md: 20, lg: 25}
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <BreadCrumbComponent 
                        list={[
                            {label: t('company'), link: "/"},
                            {label: t('footer.careers'), link: "/careers"}
                        ]}
                        activeSection={t('breadcrumbs.vacancy')}
                    />

                    <TitleComponent 
                        title={data.title}
                        description={data.role}
                        centerMode
                    />

                    {/* <TabsComponent 
                        list={[
                            {
                                label: t('careers.jobOpenings.overview'),  
                                children: <JobOverview data={data}/>
                            },
                            {
                                label: t('careers.jobOpenings.application'), 
                                children: <JobApplication data={data}/>
                            }
                        ]}
                    /> */}

                    <JobOverview data={data}/>
                </Stack>
            </Box>
        </>
    );
}

export default JobDetails;